if (!customElements.get('product-form')) {
    customElements.define('product-form', class AddToCart extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form[action$="/cart/add"]');
            this.productIdInput = this.form.querySelector('[name=id]');
            this.productIdInput.disabled = false;
            this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
        }

        formSubmit(evt) {
            evt.preventDefault();
            if(this.productIdInput.value == ''){
                this.variantError();
                return
            }
            if(document.querySelector('.product-error')){
                document.querySelector('.product-error').remove();
            }
            this.removeErrorsBlock();
			if(this.querySelectorAll('button[name="add"]')){
				this.querySelectorAll('button[name="add"]').forEach(function (button){
					button.classList.add('loading');
				})
			}
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData(this.form);
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        // Error function
                        this.errorMessage(response)
                        return;
                    }
                    // Succses function
                    this.succses()
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        errorMessage(resp) {
			console.log(resp)
            console.log(resp.description);

			if(resp.status == 422){
				this.succses();
                let productTitle = '';
                if(this.closest('.product-card-form-wrapper')){
                  productTitle = this.closest('.product-card-form-wrapper').querySelector('.product-card-title').innerHTML;
                }else if(this.closest('.main-product-right')){
                  productTitle = this.closest('.main-product-right').querySelector('.main-product-title').innerHTML;
                }
				this.errorPopup(resp.description, productTitle)

			}
			if(this.querySelectorAll('button[name="add"]')){
				this.querySelectorAll('button[name="add"]').forEach(function (button){
					button.classList.remove('loading');
				})
			}

        }

        succses() {
            console.log("Success");
			if(this.querySelectorAll('button[name="add"]')){
				this.querySelectorAll('button[name="add"]').forEach(function (button){
					button.classList.remove('loading');
					if(button.classList.contains('product-card-form-submit') || button.classList.contains('complementary-products-item-btn')){
						button.classList.add('added');
						setTimeout(function (){
							button.classList.remove('added');
						},4000)
					}
				})
			}

			if(this.closest('.cart-recommendations')){
				if(document.querySelector('cart-item')){
					document.querySelector('cart-item').updateCartContent();
				}
			}

			updateCartCount();
			updateCartPopup();
			if(!document.querySelector('.js-cart-page')){
				openCartPopup();
			}

        }
        variantError(){
			console.log("variant error")
        }
        removeErrorsBlock(){

        }

        errorPopup(text, title){
			if(document.querySelector('#error-popup')){
				document.querySelector('#error-popup').querySelector('.section-title-small').innerHTML = title;
				document.querySelector('#error-popup').querySelector('.popup-text').innerHTML = text;
				Fancybox.show([
					{
						src: "#error-popup"
					}
				]);
			}
        }

    });
}
if (!customElements.get('product-button')) {
	customElements.define('product-button', class ProductButton extends HTMLElement {
		constructor() {
			super();

			this.button = this.querySelector('button');
			this.variantId = this.button.dataset.variantId;
			if(this.button){
				this.button.addEventListener('click',this.buttonEvent.bind(this))
			}
		}

		buttonEvent(evt) {
			evt.preventDefault();

			let formData = {
				'items': [{
					"id": this.variantId,
					'quantity': 1
				}]
			}

			fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(formData)
			})
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						// Error function
						this.errorMessage(response)
						return;
					}
					// Succses function
					this.succses()
				})
				.catch((error) => {
					console.log(error);
				});
		}

		errorMessage(resp) {
			console.log(resp)
			console.log(resp.description);

		}

		succses() {
			console.log("Success");
			let iconBlock = this.button.querySelector('.option-icon');
			if(iconBlock){
				iconBlock.classList.add('added');
				setTimeout(function (){
					iconBlock.classList.remove('added');
				},4000)
			}

			updateCartCount();
			updateCartPopup();
			if(!document.querySelector('.js-cart-page')){
				openCartPopup();
			}
		}

	});
}
